import React, { Children } from 'react'
import { Link } from 'react-router-dom'
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbLink,
  BreadcrumbPage
} from '@/components/ui/breadcrumb'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { cn } from '@/helpers/utils'

const Linkcrumb = ({ label, to }) => (
  <BreadcrumbItem>
    <BreadcrumbLink asChild>
      <Link to={to}>{label}</Link>
    </BreadcrumbLink>
  </BreadcrumbItem>
)

const Textcrumb = ({ label }) => (
  <BreadcrumbItem>
    <BreadcrumbPage>{label}</BreadcrumbPage>
  </BreadcrumbItem>
)

const BreadcrumbsComponent = ({ children, className }) => {
  const childrenArray = Children.toArray(children).filter(Boolean)
  const crumbChildren = []
  const actionChildren = []
  childrenArray.forEach(child => {
    const typeName = child.type?.name
    if ([Linkcrumb.name, Textcrumb.name].includes(typeName)) {
      crumbChildren.push(child)
    } else {
      actionChildren.push(child)
    }
  })

  const childrenWithSeparators = []
  crumbChildren.forEach((child, index) => {
    childrenWithSeparators.push(child)
    if (index < crumbChildren.length - 1) {
      childrenWithSeparators.push(<BreadcrumbSeparator key={`separator-${index}`} />)
    }
  })

  return (
    <div
      className={cn(
        'flex h-16 items-center border-b bg-background px-5 shrink-0 sticky top-0 z-50',
        className
      )}
    >
      <div className='flex items-center gap-2 flex-grow'>
        <SidebarTrigger />
        <div className='flex w-2 min-h-full items-center'>
          <svg xmlns='http://www.w3.org/2000/svg' width='2' height='16' viewBox='0 0 2 16' fill='none'>
            <path d='M1 0.5V15.5' stroke='#E2E8F0' />
          </svg>
        </div>
        {crumbChildren.length > 0 && (
          <Breadcrumb>
            <BreadcrumbList>
              {childrenWithSeparators}
            </BreadcrumbList>
          </Breadcrumb>
        )}
        {actionChildren}
      </div>
    </div>
  )
}

const Breadcrumbs = BreadcrumbsComponent

Breadcrumbs.Link = Linkcrumb
Breadcrumbs.Text = Textcrumb

export default Breadcrumbs
